module.exports = __webpack_public_path__ + "static/media/quant-busd.d290500f.png";